/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Delete_ConfirmInputs */

const cs_viewings_delete_confirm = /** @type {(inputs: Viewings_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tuto prohlídku?`)
};

const en_viewings_delete_confirm = /** @type {(inputs: Viewings_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this viewing?`)
};

/**
* | output |
* | --- |
* | "Delete this viewing?" |
*
* @param {Viewings_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_delete_confirm = /** @type {((inputs?: Viewings_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_delete_confirm(inputs)
	return cs_viewings_delete_confirm(inputs)
});